import logoBB from "../../static/BB5_sm.png";
import { SYSTEM_CHOICES } from "../../components/Enumerators";
import Register from "../user/Register";
import { isMobile } from "react-device-detect";
import Login from "../user/Login";

export interface IBBZapisy {
    // system: SYSTEM_CHOICES; // BB - Bieg Belfra
}
export default function BBZapisy(props: IBBZapisy) {
    return (
        <>
            <div className="container">
                <div className="slim-wrap">
                    {isMobile ? <div className="my-6"></div> : <img alt="logo-platforma" src={logoBB} className="mt-6" />}
                    <div className="title is-size-4 mt-5  has-text-centered">Świetnie!</div>
                    <div className=" is-size-6 mt-1  has-text-centered">
                        Bieg Belfrów już w zasięgu ręki.
                        <br />W celu kontynuacji musisz się zalogować.
                        <hr />
                    </div>
                </div>
            </div>
            <div className="columns is-mobile">
                <div className="column">
                    <Login
                        system={SYSTEM_CHOICES.SYSTEM_BB}
                        noImage={true}
                        title={"Mam już konto"}
                        subtitle={"Możesz również użyć danych logowania do systemu kursów ODN Rewers."}
                        className="mr-4 has-background-light px-4 py-2"
                        hideRegisterLink={true}
                    />
                </div>

                <div className="column">
                    <Register
                        system={SYSTEM_CHOICES.SYSTEM_BB}
                        noImage={true}
                        title={"Nie mam konta"}
                        className="ml-4 px-4 py-2"
                        subtitle={"Jeżeli nie posiadasz konta, prosze załóż je."}
                    />
                </div>
            </div>
            <div className="container">
                <div className="slim-wrap">
                    <div className=" is-size-6 mt-1  has-text-centered">
                        <hr />
                    </div>
                </div>
            </div>
        </>
    );
}
